'use client';

import { useEffect } from 'react';
import { FloatingChicken } from './FloatingChicken';
import { preloadChickenAssets } from './chickenPreload';
import { useChickenSpawn } from '../hooks/useChickenSpawn';

export function ChickenManager() {
  const { spawnId, kind, amount, onClaim, onDespawn } = useChickenSpawn();

  useEffect(() => {
    preloadChickenAssets();
  }, []);

  if (!spawnId) return null;

  return <FloatingChicken key={spawnId} kind={kind} amount={amount} onClaim={onClaim} onDespawn={onDespawn} />;
}
